import { createFileRoute, redirect } from "@tanstack/react-router";

/** Old landing URL; kept so existing links keep working. */
export const Route = createFileRoute("/_authenticated/atlas/documentation/")({
  beforeLoad: () => {
    throw redirect({ to: "/atlas/overview" });
  },
});
